import "./styles.scss";

import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import Modal from "components/Modal";
import api from "libs/api";

const CreateAccountConfirmationModal = ({ email, onClose }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setLoading(true);
      await api.post("/admin/webmasters/verify-resend", { email });
      toast.success("Message resend successfully.");
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <Modal
      title={t("Create account")}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
      submit_button_label={t("Resend message")}
      variant="little-narrow"
    >
      <p>
        {t(`The webmaster account has been created. It needs to be activated before
        you can start using it.`)}
        <br />
        <br />
        {t(
          "The activation link will be sent to the following email address:"
        )}{" "}
        <strong>{email}</strong>
      </p>
    </Modal>
  );
};

export default CreateAccountConfirmationModal;
